// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"b033a30d","521":"bf131e22","707":"e6db21a3"}[chunkId] + ".js";
};